import * as React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import LegalStore from "../../stores/legalStore";
import SeekerStore from "../../stores/seekerStore";
import { Demographics, SavedOpportunity, SkillFit } from "../../models/profile";
import { Opportunity, Prereq, SetSkill} from "../../models/opportunity";
import Application from "../../models/application";
import { IDemographicsLocalization, IApplyDlgLocalization, IRegisterLocalization, IIconLocalization, ILocalization } from "../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import BackButton from "../../components/widgets/backBtn";
import TextField from "material-ui/TextField";
import { FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import Button from "material-ui/Button";
import * as s from "./apply.css";

interface IParams {
  opId: string;
}

@inject("store") @observer
export default class ApplicationVw extends React.Component<{ store: SeekerStore, params:IParams }, {}> {
  @observable agrees: boolean;
  constructor(props: any) {
    super(props);
    this.agrees = false;
  }
  @action setAgrees = (chk: boolean): void => {
    this.agrees = chk;
  }
  @action addMoreSkills = (id: string): void => {
    this.props.store.profileStore.setAddExpRoute(4);
    hashHistory.push(`opportunities/${id}`);
  }
  componentWillMount(): void {
    if (!this.props.store.viewState.requireAuthentication()) {
      return;
    }
    window.scrollTo(0, 0);
  }
  componentDidMount(): void {
    this.props.store.getHelpTopics();
  }

  renderValidation(op: Opportunity, applyLocal: IApplyDlgLocalization): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const savedOp: SavedOpportunity = this.props.store.profileStore.getSavedOpportunity(op.idHash);
    const missingPrereqs: JSX.Element[] = [];
    op.prereqs.map((p: Prereq, i:number): void => {
      if (p.mandatory && !this.props.store.opportunityStore.prereqFulfilled(p)) {
        missingPrereqs.push(<li key={i}>{p.title}</li>);
      }
    });
    const sfArray: Array<SkillFit> = savedOp.skillFit;
    const missingSkills: JSX.Element[] = [];
    if (sfArray.length > 0) {
      op.requiredSkills().map((ss: SetSkill, i: number): void => {
        const sf: SkillFit = sfArray.find((f: SkillFit): boolean => { return f.skill === ss.skillId; });
        if (!sf || sf.level === 0) {
          missingSkills.push(<li key={i}>{ss.title}</li>);
        }
      });
    } 

    return (<div>
      <Row>
        <Col xs={12} sm={6}>
          {missingPrereqs.length === 0 && <p><img src={local.icons.greenCheck} className={s.icon} />&nbsp;{applyLocal.allPrereqMsg}</p>}
          {missingPrereqs.length > 0 && <div>
            <p><img src={local.icons.warning} className={s.icon} />&nbsp;{applyLocal.missingPrereqs}</p>
          <ul>
              {missingPrereqs}
              <Button onClick={() => this.addMoreSkills(op.idHash)} style={{ margin: "16px 0px" }} raised color="secondary" aria-label="add">{local.add} {local.prereqs}</Button>
          </ul>        
          </div>
        }
      </Col>
        <Col xs={12} sm={6}>
          {missingSkills.length > 0 && <div>
            <p><img src={local.icons.warning} className={s.icon} />&nbsp;{applyLocal.missingSkills}</p>
          <ul>
              {missingSkills}
              <Button onClick={() => this.addMoreSkills(op.idHash)} style={{ margin: "16px 0px" }} raised color="secondary" aria-label="add">{local.add} {local.skills}</Button>
          </ul>         
        </div>}
      </Col>
      </Row>
      {missingPrereqs.length > 0 && <Row className={s.row}>
        <Col xs={12}><h6 className={s.displayMessage}>{applyLocal.missingPrereqMsg}</h6></Col>
      </Row>}
      </div>);
  }
  render(): JSX.Element {
    let op: Opportunity = this.props.store.opportunityStore.selectedOp;
    if (!op) {
      op = this.props.store.opportunityStore.getOpportunity(this.props.params.opId);
    }
    if (!op || !this.props.store.profileStore.profile) {
      hashHistory.push("/");
      return null;
    }
    const applyLocal: IApplyDlgLocalization = this.props.store.localization.fields.applyDlg;
    const regLocal: IRegisterLocalization = this.props.store.localization.fields.register;
    const app: Application = this.props.store.opportunityStore.application;
    if (!app) {
      this.props.store.opportunityStore.initApplication(op);
    }

    const title: string = `${applyLocal.title} ${op.name} @ ${op.postedBy}`;
    const checked: any = { color: "#5B6770" };
    const textField: any = { backgroundColor: "#ECECEC" };
    const ls: LegalStore = this.props.store.legal;
    const phonePlaceholder: string = "123-456-789";
    return (
      <div>
      <BackButton />
      <Grid>     
        <h4 className={s.blueHeader}>{title}</h4>
        <Row>
          <Col xs={12}>
            <p className={s.contactHeader} >{applyLocal.step1}</p>
          </Col>
        </Row>
        <div className={s.container}>
            <Row>
              <Col xs={12} sm={6} className={s.inputCol}>
                <TextField label={regLocal.firstName} value={app.firstName} onChange={(e) => this.props.store.opportunityStore.updateApplication("firstName", e.target.value)} />
          </Col>
              <Col xs={12} sm={6} className={s.inputCol}>
                <TextField label={regLocal.lastName} value={app.lastName} onChange={(e) => this.props.store.opportunityStore.updateApplication("lastName", e.target.value)} />
          </Col>
        </Row>
            <Row>
              <Col xs={12} sm={6} className={s.inputCol}>
                <TextField label={regLocal.phone} value={app.phone} onChange={(e) => this.props.store.opportunityStore.updateApplication("phone", e.target.value)} />
          </Col>
              <Col xs={12} sm={6} className={s.inputCol}>
                <TextField label={regLocal.emailPlaceholder} value={app.emailAddress} onChange={(e) => this.props.store.opportunityStore.updateApplication("emailAddress", e.target.value)} />
          </Col>
        </Row>
        </div>
        <Row className={s.termsAndConditions}>
            <FormControlLabel label={<div onClick={() => ls.showTermsAndConditions()} style={{textDecoration:"underline"}} dangerouslySetInnerHTML={{ __html: applyLocal.agree }}></div>} control={<Checkbox style={checked} checked={this.agrees}
            onChange={(e: object, chk: boolean) => this.setAgrees(chk)} />} />
        </Row>
        <div className={s.container}>
        <Row>
          <Col xs={12}>
            <h5 className={s.greyHeader}>{applyLocal.step2}</h5>
          {this.renderValidation(op, applyLocal)}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
          <h5 className={s.greyHeader}>{applyLocal.step3}</h5>       
          <p>{applyLocal.statementInstructions}</p>
          <TextField multiline={true} contentEditable={true} suppressContentEditableWarning={true} style={textField} fullWidth rows={5} value={app.statement} onChange={(e) => this.props.store.opportunityStore.updateApplication("statement", e.target.value)} />
          </Col>
        </Row>
        <Row className={s.btn} >
          <Button raised color="secondary" disabled={!this.agrees} onClick={this.props.store.opportunityStore.applyForOpportunity}>{applyLocal.finish}</Button>
        </Row>
            </div>
      </Grid>
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/apply/index.tsx